import { Pipe, PipeTransform } from '@angular/core';
import { isNullOrEmpty } from './../../../util/src/lib/is-null-or-empty';

export function formatOptions(value: any, options: { label?: string, value: any }[], showValue: boolean = false): any {
  const option = options?.find(x => x.value === value);
  if (showValue) {
    if (isNullOrEmpty(option)) {
      return value;
    } else {
      if (isNullOrEmpty(option!.label)) {
        return value;
      } else {
        return isNullOrEmpty(value) ? option!.label : `${option!.value} ${option!.label}`;
      }
    }
  }
  return option?.label ?? value;
}

export function formatOptionsForLocale(value: any, options: any, showValue: boolean = false, localeLang?: string): any {
  const option = options?.find((x: any) => x.value === value);
  if (showValue) {
    if (isNullOrEmpty(option)) {
      return value;
    } else {
      if (isNullOrEmpty(option!.label)) {
        return value;
      } else {
        return isNullOrEmpty(value) ? option!.label : `${option!.value} ${option!.label}`;
      }
    }
  }
  if (!isNullOrEmpty(localeLang)) {
    const displaylabel = (((option?.dropdown.languageOther ?? []).find((x: any) => x.i18nCode === localeLang)?.i18nValue)
      ?? option?.dropdown.languageEnglish) ?? option?.dropdown.name ?? value;

    return displaylabel;
  }
  return option?.label ?? value;
}

@Pipe({
  name: 'optionsMapping',
})
export class OptionsMappingPipe implements PipeTransform {
  transform(value: any, ...args: any[]): any {
    const options: { label: string; value: any }[] = args[0];
    const option = options.find((x) => x.value === value);
    return option?.label ?? value;
  }
}
